import {
  useContext,
} from 'react';
import {
  ThemeContext,
} from 'styled-components';
import {
  Droppable,
} from '@hello-pangea/dnd';

import {
  ExerciseProperty,
} from '@gymcloud/core';

import {
  Icon,
  ExercisePropertyLabel,
} from 'web-components';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import Property from './Property';
import * as S from './styled';

type Props = {
  dieRoll?: boolean,
  readOnly?: boolean,
  exerciseId: number,
  properties: ExerciseProperty[],

  onRequestDieRoll?: { (): void },
  onRequestSave?: { (id: number, payload: any, isNew: boolean): void },
  onRequestDelete?: { (propertyId: number, isNew: boolean): void },
};

const ExerciseProperties = ({
  dieRoll = false,
  readOnly = false,
  exerciseId,
  properties,
  onRequestDieRoll,
  onRequestSave,
  onRequestDelete,
}: Props) => {
  const tm = useContext(ThemeContext);
  if (!properties.length && !readOnly) {
    return (
      <Text noPrint color="#d0cfd0">
        Add metrics (such as sets, reps, etc) you would like to track
        about your client by selecting the + icon.
      </Text>
    );
  }

  return readOnly
    ? (
      <Flex
        wrap="wrap"
        spacing={10}
      >
        {properties.map(property => (
          <S.Label
            key={property.id}
            readOnly
          >
            <Icon
              type="fas fa-bars"
              size="11px"
            />
            <ExercisePropertyLabel property={property} />
          </S.Label>
        ))}
      </Flex>
    ) : (
      <>
        {dieRoll && (
          <S.Dice onClick={onRequestDieRoll}>
            <SVG.Dice stroke={readOnly ? '#B4B5B7' : tm.colors.primary} />
            <span>Die Roll</span>
          </S.Dice>
        )}

        <Droppable
          type="property"
          direction="horizontal"
          droppableId={exerciseId.toString()}
        >
          {droppableProvided => (
            <Flex
              ref={droppableProvided.innerRef}
              wrap="wrap"
            >
              {properties.map((property, index) => (
                <Property
                  key={property.id}
                  index={index}
                  property={property}
                  exerciseId={exerciseId}
                  onRequestSave={onRequestSave!}
                  onRequestDelete={onRequestDelete!}
                />
              ))}
              {droppableProvided.placeholder}
            </Flex>
          )}
        </Droppable>
      </>
    );
};

export default ExerciseProperties;
